import { render } from "./FlagOptions.vue?vue&type=template&id=37c24316"
import script from "./FlagOptions.vue?vue&type=script&lang=js"
export * from "./FlagOptions.vue?vue&type=script&lang=js"
script.render = render

export default script